// /src/components/ProtectedRoute.js

import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import api from '../api/axios';

const ProtectedRoute = ({ isAuthenticated, userRole, allowedRoles, children }) => {
  const [isVerified, setIsVerified] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkVerification = async () => {
      if (!isAuthenticated) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await api.get('/users/profile', {
          headers: { 'x-auth-token': localStorage.getItem('token') }
        });
        setIsVerified(response.data.isVerified);
      } catch (error) {
        if (error.response?.data?.error === 'EMAIL_NOT_VERIFIED') {
          setIsVerified(false);
        }
      } finally {
        setIsLoading(false);
      }
    };

    checkVerification();
  }, [isAuthenticated]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }

  // Skip verification check for guest users
  if (userRole === 'guest') {
    return children;
  }

  if (isVerified === false) {
    // Store the attempted path to redirect back after verification
    return <Navigate 
      to="/verify" 
      replace 
      state={{ 
        returnPath: location.pathname,
        email: localStorage.getItem('userEmail') // You'll need to store this during login/signup
      }} 
    />;
  }

  return children;
};

export default ProtectedRoute;